/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import { connect } from 'react-redux'


import {
  getLMSIntegrations,
  addLMSIntegration,
} from 'app/state/modules/integrations'
import { triggerLrsIntegration, setLrsReducer } from 'app/state/modules/lrs'
import {
  getTeamDetails,
} from 'app/state/modules/hacker'
import settings from 'settings'

import Icon from 'app/views/components/Icon'
import OrganizationLayout from '../components/Layout'
import IntegrationCard from '../Integrations/IntegrationCard'
import LRSSettings from '../Settings/components/LRSSettings'

class AddLMSIntegration extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      privateKey: '',
      apiUID: '',
      domain: '',
      checking: false,
      valid: null,
    }
  }

  componentDidMount() {
    this.props.getTeamDetails(this.props.match.params.organization_uuid)
    this.props.getLMSIntegrations(this.props.match.params.organization_uuid)
  }

  renderImage(key) {
    switch (key) {
      case 'exceed':
        return '/static/images/lms_integrations/exceed.jpeg'
      case 'docebo':
        return '/static/images/lms_integrations/docebo.png'
      case 'cornerstone':
        return '/static/images/lms_integrations/cornerstone.png'
      case 'lessonly':
        return '/static/images/lms_integrations/lessonly.png'
      case 'workday':
        return '/static/images/lms_integrations/workday.png'
      default:
        return null
    }
  }

  renderDefault() {
    const integrations = this.props.lmsIntegrations.filter((item) => !item.organization_uuid)
    if (integrations.length === 0) {
      return <p>You have already installed all LMS integrations available.</p>
    }
    return integrations.map((integration) => (
      <IntegrationCard
        key={`${integration.type_key}-${integration.organization_uuid || ''}`}
        small
        noHover
        imageSrc={this.renderImage(integration.type_key)}
        imageHeight={60}
        style={{
          width: 380,
          marginRight: 40,
        }}
        onClick={() => {
          this.props.history.push(`/admin/${this.props.match.params.organization_uuid}/lms-integrations/add/${integration.type_key}`)
        }}
        color={integration.type_settings.color}
        keyName="exceed"
      >
        <div
          className="uk-flex uk-flex-left uk-flex-wrap uk-flex-middle uk-widh-1-1 integration-card-description"
        >
          <h4
            className="uk-margin-remove"
          >
            {settings.integrationsLms[integration.type_key]}
          </h4>
          <div className="uk-text-right uk-margin-small-top uk-width-1-1 uk-flex uk-flex-right">
            {integration.organization_uuid ? (
              <label className="uk-label uk-label-success">ACTIVE</label>
            )
              : (
                <button
                  className="uk-button uk-button-small uk-button-secondary uk-flex uk-flex-middle"
                  type="button"
                  onClick={() => {
                    this.props.history.push(`/admin/${this.props.match.params.organization_uuid}/lms-integrations/add/${integration.type_key}`)
                  }}
                >
                  <Icon
                    ratio={0.8}
                    name="links"
                    className="uk-margin-small-right"
                  />
                    Connect
                </button>
              )}
          </div>
        </div>
      </IntegrationCard>
    ))
  }

  renderIntegrations() {
    const { integration } = this.props.match.params
    switch (integration) {
      case 'exceed':
        return (
          <>
            <div className="uk-flex uk-width-1-1 uk-flex-center uk-flex-middle uk-flex-column">
              <img src="/static/images/lms_integrations/exceed.jpeg" alt="exceed" className="uk-width-medium" />
              <div className="uk-width-xlarge uk-margin-top">
                <div className="uk-margin">
                  <label className="uk-form-label" htmlFor="domain">Domain</label>
                  <div className="uk-form-controls">
                    <input
                      className="uk-input"
                      id="domain"
                      type="text"
                      value={this.state.domain}
                      onChange={(e) => this.setState({ domain: e.target.value })}
                    />
                    <small>
                      i.e: https://example.exceedlms.com
                    </small>
                  </div>
                </div>
                <div className="uk-margin">
                  <label className="uk-form-label" htmlFor="api-uid">API UID</label>
                  <div className="uk-form-controls">
                    <input
                      className="uk-input"
                      id="api-uid"
                      type="text"
                      onChange={(e) => this.setState({ apiUID: e.target.value })}
                      value={this.state.apiUID}
                    />
                    <small>API UID with read and write permissions</small>
                  </div>
                </div>
                <div className="uk-margin">
                  <label className="uk-form-label" htmlFor="private-key">Private Key</label>
                  <div className="uk-form-controls">
                    <textarea
                      className="uk-textarea uk-text-small"
                      id="private-key"
                      type="text"
                      rows="8"
                      style={{ resize: 'none' }}
                      onChange={(e) => this.setState({ privateKey: e.target.value })}
                      value={this.state.privateKey}
                    />
                    <small>Private Key from the Exceed LMS under Settings > API</small>
                  </div>
                </div>
                {(this.state.valid === true || this.state.valid === false) && (
                  <div>
                    <label className={`uk-label uk-label-${this.state.valid ? 'success' : 'danger'}`}>
                      {this.state.valid ? 'Credentials Ok!' : 'Invalid Crededntials'}
                    </label>
                  </div>
                )}
                <div className="uk-flex uk-flex-right uk-width-1-1">
                  <button
                    disabled={(this.state.privateKey.trim() === ''
                      || this.state.apiUID.trim() === ''
                      || this.state.domain.trim() === '') || this.state.checking}
                    className="uk-button uk-button-default uk-flex-middle uk-flex uk-margin-small-right"
                    type="button"
                    onClick={() => {
                      this.setState({
                        checking: true,
                      }, () => {
                        this.props.addLMSIntegration(
                          this.props.match.params.organization_uuid,
                          {
                            domain: this.state.domain,
                            username: this.state.apiUID,
                            secret: this.state.privateKey,
                          },
                          1,
                          (valid) => this.setState({
                            checking: false,
                            valid,
                          }),
                        )
                      })
                    }}
                  >
                    <Icon
                      name="shield-keyhole"
                      className="uk-margin-right"
                    />
                    Test Credentials
                  </button>
                  <button
                    disabled={(this.state.privateKey.trim() === ''
                      || this.state.apiUID.trim() === ''
                      || this.state.domain.trim() === '') || this.state.checking}
                    className="uk-button uk-button-primary uk-flex-middle uk-flex"
                    type="button"
                    onClick={() => {
                      this.props.addLMSIntegration(
                        this.props.match.params.organization_uuid,
                        {
                          domain: this.state.domain,
                          username: this.state.apiUID,
                          secret: this.state.privateKey,
                        },
                        0,
                        () => {
                          this.props.history.push(`/admin/${this.props.match.params.organization_uuid}/lms-integrations`)
                        },
                      )
                    }}
                  >
                    <Icon
                      name="save"
                      className="uk-margin-right"
                    />
                    Save Integration
                  </button>
                </div>
              </div>
            </div>
          </>
        )
      case 'workday':
      case 'docebo':
      case 'lessonly':
      case 'cornerstone':
        return (
          <>
            <div className="uk-flex uk-width-1-1 uk-flex-center uk-flex-middle uk-flex-column">
              <img src={this.renderImage(integration)} alt={integration} className="uk-width-medium uk-border-rounded" />
              <div className="uk-width-xlarge uk-margin-top uk-text-center">
                <br />
                <br />
                <p>{`${integration.charAt(0).toUpperCase()}${integration.slice(1)} is available in exclusive beta.`}</p>
                <p>
                  Email
                  {' '}
                  <a href="mailto:support@hackedu.com">support@hackedu.com</a>
                  {' '}
                  to request access.
                </p>
                <div className="uk-flex uk-flex-center uk-margin-top">
                  <button
                    className="uk-button uk-button-small uk-button-primary uk-flex"
                    type="button"
                    onClick={() => {
                      this.props.history.goBack()
                    }}
                  >
                    <Icon
                      name="arrow-left"
                      className="uk-margin-small-right"
                    />
                    Go Back
                  </button>
                </div>
              </div>
            </div>
          </>
        )
      default:
        return (
          <div>
            <div
              className="uk-flex uk-flex-row uk-flex-wrap"
            >
              {this.renderDefault()}
            </div>
            <br />
            <hr />
            <LRSSettings
              setLrsReducer={this.props.setLrsReducer}
              lrsData={this.props.lrs}
              triggerLrsIntegration={this.props.triggerLrsIntegration}
              initialLrsValues={this.props.initialLrsValues}
            />
          </div>
        )
    }
  }

  render() {
    return (
      <OrganizationLayout
        active="lms_integrations"
        // isLoading={this.props.loadingIntegrations}
        {...this.props}
      >
        <h1>Add LMS Integration</h1>
        {this.renderIntegrations()}
      </OrganizationLayout>
    )
  }
}

const mapStateToProps = ({ hacker, integrations, lrs }) => ({
  organizations: hacker.organizationsList,
  organizationsHash: hacker.organizationsHash,
  lmsIntegrations: integrations.lmsIntegrations,
  lrs,
  initialLrsValues: hacker.currentTeamDetails.lrs,
})

export default connect(mapStateToProps, {
  getLMSIntegrations,
  addLMSIntegration,
  triggerLrsIntegration,
  setLrsReducer,
  getTeamDetails,
})(AddLMSIntegration)
